import {
    Alert,
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    InputLabel,
    LinearProgress,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    MenuItem,
    Select,
    Stack,
    Typography
} from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import getDomain from "./domain"


export default function TvControls (params) {

    const { selection, callback} = params

    const [visible, setVisible] = useState(false)

    const [seasons, setSeasons] = useState()


    const [selectedSeason, setSelectedSeason] = useState('');
    const [episodes, setEpisodes] = useState([]);
    const [selectedEpisode, setSelectedEpisode] = useState('');

    const handleSeasonChange = async (event) => {
        console.log(event)
        const seasonNumber = event.target.value;
        setSelectedSeason(seasonNumber);
        console.log(seasonNumber)
        setSelectedEpisode(''); // Reset selected episode
        if (seasonNumber) {
            const fetchedEpisodes = seasonNumber.episodes;
            setEpisodes(fetchedEpisodes);
        } else {
            setEpisodes([]);
        }
    };

    const handleEpisodeChange = (event) => {
        setSelectedEpisode(event.target.value);
    };




    const getShowInfo = async () => {

        const url = `https://api.themoviedb.org/3/tv/${selection.id}?language=en-US`;
        const options = {
        method: 'GET',
        headers: {
            accept: 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxNWIyODkyMDc2MmQxZDhhOTEzOGMyOWRkMWU4NDA1ZSIsIm5iZiI6MTcwNzAwNzE2Ni4xNTI5OTk5LCJzdWIiOiI2NWJlZGNiZWE3ZTM2MzAxODQ1NDg2MDgiLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.0CxslnwYprMfYDQQ8GDtcDGTNd6mUQeNl9cVXVX-ENg'
        }
        };

        var res = await fetch(url, options)
        var json = await res.json()

        var seasonsMap = []

        for (let season of json.seasons) {

            var seasonRes = await fetch(`https://api.themoviedb.org/3/tv/${selection.id}/season/${season.season_number}?language=en-US`, options)
            var seasonJson = await seasonRes.json()
            seasonsMap.push(seasonJson)
        }

        console.log(seasonsMap)
        setSeasons(seasonsMap)


    }

    useEffect(() => {
        let s 
        let e
        if (selectedSeason.season_number < 10) { s = `S0${selectedSeason.season_number}` } else if (selectedSeason.season_number === null) {s = ""} else { s = `S${selectedSeason.season_number}` }
        if (selectedEpisode < 10) { e = `E0${selectedEpisode}` } else if (selectedEpisode === 0){ e = ""} else { e = `E${selectedEpisode}` }
        var newQuery = `${selection.name} ${selectedSeason ? s : ""}${selectedEpisode ? e : ""}`
        callback(newQuery)

    }, [selectedEpisode, selectedSeason, selection, callback])

    useEffect(() => {
        if(selection?.first_air_date ?? false) {setVisible(true)}
        if(selection?.first_air_date ?? false) {
            getShowInfo()
        }
    }, [selection])


    if (seasons) {

        return (
            <Stack direction={'row'} spacing={2} alignItems="center">
                <FormControl fullWidth>
                    <InputLabel id="season-select-label">Season</InputLabel>
                    <Select
                        labelId="season-select-label"
                        value={selectedSeason}
                        onChange={handleSeasonChange}
                        label="Season"
                    >
                        {seasons.map((season, index) => (
                            <MenuItem key={index} value={season}>
                                {season.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="episode-select-label">Episode</InputLabel>
                    <Select
                        labelId="episode-select-label"
                        value={selectedEpisode}
                        onChange={handleEpisodeChange}
                        label="Episode"
                    >
                        <MenuItem key={0} value={null}>
                                {`None`}
                            </MenuItem>
                        {episodes.map((episode) => (
                            <MenuItem key={episode.id} value={episode.episode_number}>
                                {`Episode ${episode.episode_number} - ${episode.name} (${episode.air_date || 'N/A'})`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <BulkDownloadDialog selection={selection} seasons={seasons} />
            </Stack>
        )

    }


}

function BulkDownloadDialog({ selection, seasons }) {

    const [open, setOpen] = useState(false)
    const [selectedEpisodes, setSelectedEpisodes] = useState({})
    const [running, setRunning] = useState(false)
    const [progress, setProgress] = useState("")
    const [error, setError] = useState("")
    const [manualQueue, setManualQueue] = useState([])
    const [manualIndex, setManualIndex] = useState(0)
    const [manualResults, setManualResults] = useState([])
    const [manualSearching, setManualSearching] = useState(false)

    const episodes = useMemo(() => {
        if (!seasons) { return [] }

        return seasons.flatMap((season) =>
            (season.episodes ?? []).map((episode) => ({
                id: `${season.season_number}-${episode.episode_number}`,
                seasonNumber: season.season_number,
                seasonName: season.name,
                episodeNumber: episode.episode_number,
                episodeName: episode.name,
                airDate: episode.air_date,
                query: buildEpisodeQuery(selection.name, season.season_number, episode.episode_number)
            }))
        )
    }, [seasons, selection])

    const selectedList = useMemo(() => {
        return episodes.filter((episode) => selectedEpisodes[episode.id])
    }, [episodes, selectedEpisodes])

    const selectedCount = selectedList.length
    const allSelected = episodes.length > 0 && selectedCount === episodes.length
    const mode = manualQueue.length > 0 ? "manual" : "select"
    const currentManualEpisode = manualQueue[manualIndex]

    useEffect(() => {
        if (mode !== "manual" || !currentManualEpisode) { return }

        let cancelled = false

        async function searchCurrentEpisode() {
            setManualSearching(true)
            setManualResults([])
            setError("")
            setProgress(`Searching ${formatEpisode(currentManualEpisode)} (${manualIndex + 1}/${manualQueue.length})`)

            try {
                const results = await searchEpisode(currentManualEpisode.query)
                if (!cancelled) {
                    setManualResults(sortResults(results))
                }
            } catch (e) {
                if (!cancelled) {
                    setError(`Failed searching ${formatEpisode(currentManualEpisode)}: ${e.message}`)
                }
            } finally {
                if (!cancelled) {
                    setManualSearching(false)
                }
            }
        }

        searchCurrentEpisode()

        return () => {
            cancelled = true
        }
    }, [mode, currentManualEpisode, manualIndex, manualQueue.length])

    const resetRunState = () => {
        setRunning(false)
        setProgress("")
        setError("")
        setManualQueue([])
        setManualIndex(0)
        setManualResults([])
        setManualSearching(false)
    }

    const handleClose = () => {
        if (running || manualSearching) { return }

        setOpen(false)
        resetRunState()
    }

    const selectAll = () => {
        setSelectedEpisodes(Object.fromEntries(episodes.map((episode) => [episode.id, true])))
    }

    const selectNone = () => {
        setSelectedEpisodes({})
    }

    const toggleEpisode = (episode, checked) => {
        setSelectedEpisodes((current) => ({
            ...current,
            [episode.id]: checked
        }))
    }

    const toggleSeason = (season, checked) => {
        const seasonEpisodeIds = episodes
            .filter((episode) => episode.seasonNumber === season.season_number)
            .map((episode) => episode.id)

        setSelectedEpisodes((current) => {
            const next = { ...current }
            for (const episodeId of seasonEpisodeIds) {
                next[episodeId] = checked
            }
            return next
        })
    }

    const batchDownloadTopResults = async () => {
        if (selectedList.length === 0) { return }

        setRunning(true)
        setError("")

        try {
            for (let i = 0; i < selectedList.length; i++) {
                const episode = selectedList[i]
                setProgress(`Downloading top result for ${formatEpisode(episode)} (${i + 1}/${selectedList.length})`)

                const results = sortResults(await searchEpisode(episode.query))
                if (results.length === 0) {
                    console.warn(`No results found for ${episode.query}`)
                    continue
                }

                await sendTorrent(results[0])
            }

            setProgress(`Completed ${selectedList.length} episode searches.`)
        } catch (e) {
            setError(e.message)
        } finally {
            setRunning(false)
        }
    }

    const startManualSelection = () => {
        if (selectedList.length === 0) { return }

        setError("")
        setManualResults([])
        setManualIndex(0)
        setManualQueue(selectedList)
    }

    const chooseManualResult = async (result) => {
        setRunning(true)
        setError("")

        try {
            setProgress(`Sending ${formatEpisode(currentManualEpisode)} to download`)
            await sendTorrent(result)

            const nextIndex = manualIndex + 1
            if (nextIndex >= manualQueue.length) {
                setProgress(`Completed ${manualQueue.length} manually selected downloads.`)
                setManualQueue([])
                setManualIndex(0)
                setManualResults([])
            } else {
                setManualIndex(nextIndex)
            }
        } catch (e) {
            setError(e.message)
        } finally {
            setRunning(false)
        }
    }

    return (
        <>
            <Button
                variant="outlined"
                onClick={() => {
                    resetRunState()
                    setSelectedEpisodes(Object.fromEntries(episodes.map((episode) => [episode.id, true])))
                    setOpen(true)
                }}
                disabled={!episodes.length}
            >
                Download Bulk
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle>Download Bulk - {selection.name}</DialogTitle>
                <DialogContent dividers>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    {(running || manualSearching) && <LinearProgress sx={{ mb: 2 }} />}
                    {progress && <Alert severity="info" sx={{ mb: 2 }}>{progress}</Alert>}

                    {mode === "select" && (
                        <Stack spacing={2}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Button variant="contained" onClick={selectAll} disabled={allSelected || running}>Select All</Button>
                                <Button variant="outlined" onClick={selectNone} disabled={selectedCount === 0 || running}>Select None</Button>
                                <Chip label={`${selectedCount} selected`} />
                            </Stack>

                            <Box sx={{ maxHeight: 500, overflow: 'auto', border: '1px solid #ddd', borderRadius: 1 }}>
                                {seasons.map((season) => {
                                    const seasonEpisodes = episodes.filter((episode) => episode.seasonNumber === season.season_number)
                                    const seasonSelectedCount = seasonEpisodes.filter((episode) => selectedEpisodes[episode.id]).length
                                    const checked = seasonEpisodes.length > 0 && seasonSelectedCount === seasonEpisodes.length
                                    const indeterminate = seasonSelectedCount > 0 && seasonSelectedCount < seasonEpisodes.length

                                    return (
                                        <Box key={season.id ?? season.season_number}>
                                            <Box sx={{ px: 2, py: 1, backgroundColor: '#f5f5f5' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={checked}
                                                            indeterminate={indeterminate}
                                                            onChange={(event) => toggleSeason(season, event.target.checked)}
                                                        />
                                                    }
                                                    label={`${season.name} (${seasonSelectedCount}/${seasonEpisodes.length})`}
                                                />
                                            </Box>
                                            {seasonEpisodes.map((episode) => (
                                                <Box key={episode.id} sx={{ pl: 4, pr: 2 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(selectedEpisodes[episode.id])}
                                                                onChange={(event) => toggleEpisode(episode, event.target.checked)}
                                                            />
                                                        }
                                                        label={`Episode ${episode.episodeNumber} - ${episode.episodeName} (${episode.airDate || 'N/A'})`}
                                                    />
                                                </Box>
                                            ))}
                                            <Divider />
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Stack>
                    )}

                    {mode === "manual" && currentManualEpisode && (
                        <Stack spacing={2}>
                            <Typography variant="h6">
                                Pick listing for {formatEpisode(currentManualEpisode)}
                            </Typography>
                            <Typography variant="body2">
                                Query: {currentManualEpisode.query}
                            </Typography>
                            {manualSearching && <Typography>Searching...</Typography>}
                            {!manualSearching && manualResults.length === 0 && (
                                <Alert severity="warning">No results found. Choose Skip to continue.</Alert>
                            )}
                            <List sx={{ maxHeight: 500, overflow: 'auto', border: '1px solid #ddd', borderRadius: 1 }}>
                                {manualResults.map((result) => (
                                    <ListItem
                                        key={result.id ?? result.trackerId}
                                        disablePadding
                                        secondaryAction={
                                            <Button variant="contained" onClick={() => chooseManualResult(result)} disabled={running}>
                                                Download
                                            </Button>
                                        }
                                    >
                                        <ListItemButton onClick={() => chooseManualResult(result)} disabled={running}>
                                            <ListItemText
                                                primary={result.title}
                                                secondary={`${formatSize(result.size)} • ${result.seeds ?? 0} seeds • ${result.metadata?.resolution ?? 'Unknown'}p`}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Stack>
                    )}
                </DialogContent>
                <DialogActions>
                    {mode === "manual" && (
                        <Button
                            onClick={() => {
                                const nextIndex = manualIndex + 1
                                if (nextIndex >= manualQueue.length) {
                                    setManualQueue([])
                                    setManualIndex(0)
                                    setManualResults([])
                                    setProgress("Manual selection complete.")
                                } else {
                                    setManualIndex(nextIndex)
                                }
                            }}
                            disabled={running || manualSearching}
                        >
                            Skip
                        </Button>
                    )}
                    <Button onClick={handleClose} disabled={running || manualSearching}>Close</Button>
                    {mode === "select" && (
                        <>
                            <Button onClick={startManualSelection} disabled={selectedCount === 0 || running}>
                                Pick Listings One by One
                            </Button>
                            <Button variant="contained" onClick={batchDownloadTopResults} disabled={selectedCount === 0 || running}>
                                Batch Download
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </>
    )
}

function buildEpisodeQuery(showName, seasonNumber, episodeNumber) {
    const season = seasonNumber < 10 ? `S0${seasonNumber}` : `S${seasonNumber}`
    const episode = episodeNumber < 10 ? `E0${episodeNumber}` : `E${episodeNumber}`

    return `${showName} ${season}${episode}`
}

function formatEpisode(episode) {
    return `${episode.seasonName} Episode ${episode.episodeNumber} - ${episode.episodeName}`
}

function formatSize(size) {
    if (!size) { return "Unknown size" }

    return `${(size / 1073741824).toFixed(2)} GB`
}

function sortResults(results) {
    return [...(results ?? [])].sort((a, b) => {
        const resolutionA = parseInt(a.metadata?.resolution ?? 0)
        const resolutionB = parseInt(b.metadata?.resolution ?? 0)
        const seedsA = parseInt(a.seeds ?? 0)
        const seedsB = parseInt(b.seeds ?? 0)

        if (resolutionB !== resolutionA) { return resolutionB - resolutionA }
        return seedsB - seedsA
    })
}

async function searchEpisode(query) {
    const response = await fetch(`${getDomain()}/tg?query=${encodeURIComponent(query)}`)

    if (!response.ok) {
        throw new Error(`Search failed for ${query}`)
    }

    return await response.json()
}

async function sendTorrent(result) {
    const response = await fetch(`${getDomain()}/add?category=tv`, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify({magnet: result.trackerId, category: "tv"})
    })

    if (!response.ok) {
        throw new Error(`Download request failed for ${result.title}`)
    }

    return await response.json()
}
